import React from 'react';
import moment from 'moment';

const TimelineHeader = ({ entityName, metadata, entityType }) => {
    const typeLabel = entityType === 'school' ? 'School' : 'Distributor';
    
    return (
        <div>
            <h4 className="header-title mb-1">
                Visit History for: <span className='text-primary'>{entityName}</span>
            </h4>
            {metadata && (
                <div className="text-muted" style={{ fontSize: '14px' }}>
                    <span className="me-3">
                        <i className="mdi mdi-map-marker-outline me-1"></i>
                        {metadata.city}, {metadata.state}
                    </span>
                    <span className="me-3">
                        <i className="mdi mdi-account-circle-outline me-1"></i>
                        Created by: {metadata.createdBy}
                    </span>
                    <span>
                        <i className="mdi mdi-calendar-blank-outline me-1"></i>
                        Created At: {moment(metadata.createdAt).format('DD MMM YYYY')}
                    </span>
                </div>
            )}
        </div>
    );
};

export default TimelineHeader;
